import React, { Fragment } from "react";
import { Col, Row } from "react-bootstrap";

import masTiempo from "../../assets/ImgRazonTres.png";
import clock from "../../assets/clock.png";
import snorkel from "../../assets/snorkel.png";
import ok from "../../assets/ok.png";

const RazonTres = () => {
  return (
    <Fragment>
      <Col lg={4}>
        <h4>Razón #3</h4>
        <h2
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Más tiempo para vos
        </h2>
      </Col>
      <Col lg={5}>
        <p
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Nuestras piscinas cuentan con un óptimo equipamiento de filtrado que
          conserva la limpieza de tu piscina.
        </p>
      </Col>

      <Col lg={3} className="icons">
        <marquee
          bgcolor="transparent"
          width="50%"
          scrolldelay="100"
          scrollamount="5"
          direction="up"
          loop="infinite"
          align="middle"
        >
          <img src={clock} alt="Mas tiempo"></img>
          <img src={snorkel} alt="Mas tiempo"></img>
          <img src={ok} alt="Mas tiempo"></img>
          <img src={clock} alt="Mas tiempo"></img>
          <img src={snorkel} alt="Mas tiempo"></img>
          <img src={ok} alt="Mas tiempo"></img>
          <img src={clock} alt="Mas tiempo"></img>
          <img src={snorkel} alt="Mas tiempo"></img>
          <img src={ok} alt="Mas tiempo"></img>
          <img src={clock} alt="Mas tiempo"></img>
          <img src={snorkel} alt="Mas tiempo"></img>
          <img src={ok} alt="Mas tiempo"></img>
        </marquee>
        <div id="backRollIcons"></div>
      </Col>
    </Fragment>
  );
};

export default RazonTres;
